import { render } from "./DeclencheurQuitSite.vue?vue&type=template&id=397a64d7"
import script from "./DeclencheurQuitSite.vue?vue&type=script&lang=ts"
export * from "./DeclencheurQuitSite.vue?vue&type=script&lang=ts"
script.render = render

export default script